import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.nav.admin');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-portal-nrich-nav-admin',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichNavAdminComponent implements OnInit {
    public currentPath: string = '';
    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public menus: any[] = [
        {
            group: '모니터링',
            items: [
                { label: '대시보드', path: '/admin/dashboard', icon: 'dashboard' },
                { label: '파이프라인', path: '/admin/pipeline', icon: 'pipeline' },
                { label: '질의 로그', path: '/admin/queries', icon: 'search' },
                { label: '토큰/비용', path: '/admin/tokens', icon: 'tokens' },
            ]
        },
        {
            group: '검수/운영',
            items: [
                { label: '검수 관리', path: '/admin/review', icon: 'review' },
                { label: '검증 게이트', path: '/admin/verify', icon: 'verify' },
                { label: '문서 관리', path: '/admin/documents', icon: 'document' },
                { label: '지식그래프', path: '/admin/kg', icon: 'kg' },
                { label: '용어 관리', path: '/admin/terms', icon: 'terms' },
            ]
        },
        {
            group: '설정',
            items: [
                { label: '모델 설정', path: '/admin/models', icon: 'models' },
                { label: '사용자 관리', path: '/admin/users', icon: 'users' },
                { label: '프롬프트 관리', path: '/admin/prompts', icon: 'prompts' },
                { label: '운영 설정', path: '/admin/settings', icon: 'settings' },
            ]
        }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.currentPath = window.location.pathname;
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                this.currentPath = event.urlAfterRedirects || event.url;
                await this.service.render();
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public isActive(path: string): boolean {
        return this.currentPath.startsWith(path);
    }

    public logout() {
        location.href = '/auth/logout';
    }
}

export default PortalNrichNavAdminComponent;